import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('searchAddressWithNo'),
}
const searchAddressWithNo = payload => {
  return {
    type: actions.LOAD,
    payload,
  }
}

export { actions, searchAddressWithNo }
